export const mappedColumns = [
  {
    group: 'Lead',
    id: 'lead',
    type: 'group',
    subOptions: [
      { label: 'First Name', id: 'firstName', type: 'text' },
      { label: 'Last Name', id: 'lastName', type: 'text' },
      { label: 'Email', id: 'email', type: 'text' },
      { label: 'Phone Number', id: 'phoneNumber', type: 'text' },
      { label: 'Created Date', id: 'createdAt', type: 'datetime' },
      { label: 'Property Address', id: 'metaInformation.propertyAddress', type: 'text' },
      { label: 'Renewal Date', id: 'metaInformation.renewalDate', type: 'datetime' },
      { label: 'Mortgage Amount', id: 'metaInformation.mortgageAmount', type: 'currency' },
    ],
  },
    {
      group: 'Deal',
      id: 'deal',
      type: 'group',
      subOptions: [
        {
          label: 'Origin',
          id: 'origin',
          type: 'enum',
          options: [
            { label: 'Funnels', id: 'FUNNELS', value: 'FUNNELS' },
            { label: 'Portal', id: 'PORTAL', value: 'PORTAL' },
            { label: 'Legacy', id: 'LEGACY', value: 'LEGACY' },
            { label: 'Opportunity', id: 'OPPORTUNITY', value: 'OPPORTUNITY' },
          ],
        },
        {
          label: 'Mortgage State',
          id: 'dealMortgageState',
          type: 'enum',
          options: [
            { label: 'Active', id: 'ACTIVE', value: 'ACTIVE' },
            { label: 'Inactive', id: 'INACTIVE', value: 'INACTIVE' },
            { label: 'Pending', id: 'PENDING', value: 'PENDING' },
            { label: 'Unknown', id: 'UNKNOWN', value: 'UNKNOWN' },
          ],
        },
        { label: 'Created date', id: 'createdDate', type: 'datetime' },
        { label: 'Tags', id: 'tags', type: 'tag' },
        { label: 'Legacy tags', id: 'legacyTags', type: 'array' },
        { label: 'Last activity date', id: 'lastActivityDate', type: 'datetime' },
        {
          label: 'Referral source type',
          id: 'referralSource',
          type: 'enum',
          options: [
            { label: 'Agent', id: 'AGENT', value: 'AGENT' },
            {
              label: 'Friend or family',
              id: 'FRIEND_OR_FAMILY',
              value: 'FRIEND_OR_FAMILY',
            },
            { label: 'Google', id: 'GOOGLE', value: 'GOOGLE' },
            {
              label: 'Facebook instagram',
              id: 'FB_INSTAGRAM',
              value: 'FB_INSTAGRAM',
            },
            { label: 'Internet', id: 'INTERNET', value: 'INTERNET' },
            {
              label: 'Other internet',
              id: 'OTHER_INTERNET',
              value: 'OTHER_INTERNET',
            },
            { label: 'TV', id: 'TV', value: 'TV' },
            { label: 'Radio', id: 'RADIO', value: 'RADIO' },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
          ],
        },
        { label: 'Affiliate key', id: 'affiliateKey', type: 'string' },
        {
          label: 'Deal state',
          id: 'state',
          type: 'enum',
          options: [
            { label: 'Opportunity', id: 'OPPORTUNITY', value: 'OPPORTUNITY' },
            { label: 'Lead', id: 'LEAD', value: 'LEAD' },
            { label: 'On hold', id: 'ON_HOLD', value: 'ON_HOLD' },
            { label: 'In progress', id: 'IN_PROGRESS', value: 'IN_PROGRESS' },
            { label: 'Closed', id: 'CLOSED', value: 'CLOSED' },
            { label: 'Cancelled', id: 'CANCELLED', value: 'CANCELLED' },
          ],
        },
        {
          label: 'Purpose',
          id: 'purpose',
          type: 'enum',
          options: [
            { label: 'Purchase', id: 'PURCHASE', value: 'PURCHASE' },
            { label: 'Refinance', id: 'REFINANCE', value: 'REFINANCE' },
            { label: 'Home equity loan', id: 'ETO', value: 'ETO' },
            {
              label: 'Renewal/Switch/Transfer',
              id: 'SWITCH_TRANSFER',
              value: 'SWITCH_TRANSFER',
            },
          ],
        },
        { label: 'Position', id: 'position', type: 'int' },
        { label: 'Is pre-approval', id: 'isPreApproval', type: 'bool' },
        {
          label: 'Estimated closing date',
          id: 'estimatedClosingDate',
          type: 'datetime',
        },
        {
          label: 'Has selected application',
          id: 'hasSelectedApplication',
          type: 'bool',
        },
        { label: 'Purchase price', id: 'purchasePrice', type: 'currency' },
        { label: 'Down payment', id: 'downPayment', type: 'currency' },
        { label: 'Requested amount', id: 'requestedAmount', type: 'currency' },
        {
          label: 'Occupancy',
          id: 'occupancy',
          type: 'enum',
          options: [
            {
              label: 'Owner occupied',
              id: 'OWNER_OCCUPIED',
              value: 'OWNER_OCCUPIED',
            },
            {
              label: 'Owner occupied and rental',
              id: 'OWNER_OCCUPIED_AND_RENTAL',
              value: 'OWNER_OCCUPIED_AND_RENTAL',
            },
            { label: 'Rental', id: 'RENTAL', value: 'RENTAL' },
            { label: 'Second home', id: 'SECOND_HOME', value: 'SECOND_HOME' },
          ],
        },
        {
          label: 'Estimated total assets',
          id: 'estimatedTotalAssets',
          type: 'currency',
        },
        {
          label: 'Estimated total liabilities',
          id: 'estimatedTotalLiabilities',
          type: 'currency',
        },
        {
          label: 'Best time to contact',
          id: 'bestTimeToContact',
          type: 'enum',
          options: [
            { label: 'Anytime', id: 'ANYTIME', value: 'ANYTIME' },
            { label: 'Morning', id: 'MORNING', value: 'MORNING' },
            { label: 'Daytime', id: 'DAYTIME', value: 'DAYTIME' },
            { label: 'Evening', id: 'EVENING', value: 'EVENING' },
            { label: 'Weekend', id: 'WEEKEND', value: 'WEEKEND' },
          ],
        },
        { label: 'Primary Agent Name', id: 'primaryAgent.fullName', type: 'user' },
        { label: 'Primary Agent WorkPhone', id: 'primaryAgent.workPhone', type: 'user' },
        { label: 'Primary Agent Email', id: 'primaryAgent.accountEmailAddress', type: 'user' },
        { label: 'Primary Agent Title', id: 'primaryAgent.title', type: 'user' },
        { label: 'Primary Agent Picture', id: 'primaryAgent.profilePic', type: 'user' },
        { label: 'Other Agent names', id: 'participants.fullName', type: 'user' },
        { label: 'Other Agent WorkPhones', id: 'participants.workPhone', type: 'user' },
        { label: 'Other Agent Emails', id: 'participants.email', type: 'user' },
        { label: 'Loan amount', id: 'loanAmount', type: 'currency' },
        { label: 'Current LTV', id: 'ltv', type: 'float' },
        { label: 'Total assets', id: 'totalAssets', type: 'currency' },
        {
          label: 'Total income yearly',
          id: 'totalIncomeYearlyDollars',
          type: 'currency',
        },
        { label: 'Total liabilities', id: 'totalLiabilities', type: 'currency' },
        {
          label: 'Total liability credit limits',
          id: 'totalLiabilityCreditLimits',
          type: 'currency',
        },
        {
          label: 'Total liability payments',
          id: 'totalLiabilityPayments',
          type: 'currency',
        },
        {
          label: 'Total other property condo fees',
          id: 'totalOtherPropertyCondoFees',
          type: 'currency',
        },
        {
          label: 'Total other property mortgage balance',
          id: 'totalOtherPropertyMortgageBalance',
          type: 'currency',
        },
        {
          label: 'Total other property mortgage payments',
          id: 'totalOtherPropertyMortgagePayments',
          type: 'currency',
        },
        {
          label: 'Total other property taxes',
          id: 'totalOtherPropertyTaxes',
          type: 'currency',
        },
        {
          label: 'Total other property value',
          id: 'totalOtherPropertyValue',
          type: 'currency',
        },
        {
          label: 'Total secured liability payments',
          id: 'totalSecuredLiabilityPayments',
          type: 'currency',
        },
        {
          label: 'Total subject property condo fees',
          id: 'totalSubjectPropertyCondoFees',
          type: 'currency',
        },
        {
          label: 'Total subject property heating',
          id: 'totalSubjectPropertyHeating',
          type: 'currency',
        },
        {
          label: 'Total subject property mortgage balance',
          id: 'totalSubjectPropertyMortgageBalance',
          type: 'currency',
        },
        {
          label: 'Total subject property mortgage payments',
          id: 'totalSubjectPropertyMortgagePayments',
          type: 'currency',
        },
        {
          label: 'Total subject property taxes',
          id: 'totalSubjectPropertyTaxes',
          type: 'currency',
        },
        {
          label: 'Total subject property value',
          id: 'totalSubjectPropertyValue',
          type: 'currency',
        },
      ],
    },
    {
      group: 'Assets',
      id: 'assets',
      type: 'group',
      subOptions: [
        { label: 'Id', id: 'assets.id', type: 'string' },
        {
          label: 'Type',
          id: 'assets.type',
          type: 'limitedEnum',
          options: [
            { label: 'Savings', id: 'SAVINGS', value: 'SAVINGS' },
            { label: 'RRSP', id: 'RRSP', value: 'RRSP' },
            { label: 'Gift', id: 'GIFT', value: 'GIFT' },
            { label: 'Vehicle', id: 'VEHICLE', value: 'VEHICLE' },
            {
              label: 'Stocks bonds mutual',
              id: 'STOCKS_BONDS_MUTUAL',
              value: 'STOCKS_BONDS_MUTUAL',
            },
            {
              label: 'Household goods',
              id: 'HOUSEHOLD_GOODS',
              value: 'HOUSEHOLD_GOODS',
            },
            {
              label: 'Life insurance',
              id: 'LIFE_INSURANCE',
              value: 'LIFE_INSURANCE',
            },
            {
              label: 'Deposit on purchase',
              id: 'DEPOSIT_ON_PURCHASE',
              value: 'DEPOSIT_ON_PURCHASE',
            },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
          ],
        },
        { label: 'Borrowers', id: 'assets.borrowers', type: 'string' },
        { label: 'Description', id: 'assets.description', type: 'string' },
        { label: 'Value', id: 'assets.value', type: 'currency' },
      ],
    },
    {
      group: 'Liabilities',
      id: 'Liability',
      type: 'group',
      subOptions: [
        { label: 'Id', id: 'liabilities.id', type: 'string' },
        {
          label: 'Type',
          id: 'liabilities.type',
          type: 'enum',
          options: [
            { label: 'Savings', id: 'SAVINGS', value: 'SAVINGS' },
            { label: 'RRSP', id: 'RRSP', value: 'RRSP' },
            { label: 'Gift', id: 'GIFT', value: 'GIFT' },
            { label: 'Vehicle', id: 'VEHICLE', value: 'VEHICLE' },
            {
              label: 'Stocks bonds mutual',
              id: 'STOCKS_BONDS_MUTUAL',
              value: 'STOCKS_BONDS_MUTUAL',
            },
            {
              label: 'Household goods',
              id: 'HOUSEHOLD_GOODS',
              value: 'HOUSEHOLD_GOODS',
            },
            {
              label: 'Life insurance',
              id: 'LIFE_INSURANCE',
              value: 'LIFE_INSURANCE',
            },
            {
              label: 'Deposit on purchase',
              id: 'DEPOSIT_ON_PURCHASE',
              value: 'DEPOSIT_ON_PURCHASE',
            },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
          ],
        },
        { label: 'Borrowers', id: 'liabilities.borrowers', type: 'string' },
        { label: 'Description', id: 'liabilities.description', type: 'string' },
        { label: 'Amount', id: 'liabilities.amount', type: 'currency' },
        {
          label: 'Credit limit',
          id: 'liabilities.creditLimit',
          type: 'currency',
        },
        {
          label: 'Monthly payment',
          id: 'liabilities.monthlyPayment',
          type: 'currency',
        },
        {
          label: 'Monthly payment',
          id: 'liabilities.PayoffType',
          type: 'enum',
          options: [
            {
              label: 'Prior to advance',
              id: 'PRIOR_TO_ADVANCE',
              value: 'PRIOR_TO_ADVANCE',
            },
            { label: 'At maturity', id: 'AT_MATURITY', value: 'AT_MATURITY' },
            {
              label: 'From proceeds',
              id: 'FROM_PROCEEDS',
              value: 'FROM_PROCEEDS',
            },
          ],
        },
        {
          label: 'Pay off amount',
          id: 'liabilities.payOffAmount',
          type: 'currency',
        },
        {
          label: 'Maturity date',
          id: 'liabilities.maturityDate',
          type: 'datetime',
        },
        { label: 'Refinanced', id: 'liabilities.refinanced', type: 'bool' },
      ],
    },
    {
      group: 'Primary Borrower',
      id: 'primaryBorrower',
      type: 'group',
      subOptions: [
        {
          label: 'Contact ID',
          id: 'primaryBorrower.contact.id',
          type: 'string',
        },
        {
          label: 'Contact salutation',
          id: 'primaryBorrower.contact.salutation',
          type: 'string',
        },
        {
          label: 'Contact first name',
          id: 'primaryBorrower.contact.firstName',
          type: 'string',
        },
        {
          label: 'Contact middle initial',
          id: 'primaryBorrower.contact.middleInitial',
          type: 'string',
        },
        {
          label: 'Contact last name',
          id: 'primaryBorrower.contact.lastName',
          type: 'string',
        },
        {
          label: 'Contact suffix',
          id: 'primaryBorrower.contact.suffix',
          type: 'string',
        },
        {
          label: 'Contact birth date',
          id: 'primaryBorrower.contact.birthDate',
          type: 'datetime',
        },
        { label: 'Contact email', id: 'primaryBorrower.contact.email', type: 'string' },
        {
          label: 'Contact home phone number',
          id: 'primaryBorrower.contact.homePhone.number',
          type: 'string',
        },
        {
          label: 'Contact home phone ext',
          id: 'primaryBorrower.contact.homePhone.ext',
          type: 'string',
        },
        {
          label: 'Contact work phone number',
          id: 'primaryBorrower.contact.workPhone.number',
          type: 'string',
        },
        {
          label: 'Contact work phone ext',
          id: 'primaryBorrower.contact.workPhone.ext',
          type: 'string',
        },
        {
          label: 'Contact cell phone number',
          id: 'primaryBorrower.contact.cellPhone.number',
          type: 'string',
        },
        {
          label: 'Contact cell phone ext',
          id: 'primaryBorrower.contact.cellPhone.ext',
          type: 'string',
        },
        {
          label: 'Contact preferred contact method',
          id: 'primaryBorrower.contact.preferredContact',
          type: 'enum',
          options: [
            { label: 'Home phone', id: 'HOME_PHONE', value: 'HOME_PHONE' },
            { label: 'Work phone', id: 'WORK_PHONE', value: 'WORK_PHONE' },
            { label: 'Cell phone', id: 'CELL_PHONE', value: 'CELL_PHONE' },
            { label: 'Guarantor', id: 'GUARANTOR', value: 'GUARANTOR' },
            { label: 'Fax', id: 'FAX', value: 'FAX' },
            { label: 'Email', id: 'EMAIL', value: 'EMAIL' },
            { label: 'Mail', id: 'MAIL', value: 'MAIL' },
          ],
        },
        {
          label: 'Contact industries',
          id: 'primaryBorrower.contact.industries',
          type: 'string',
        },
        {
          label: 'Contact occupations',
          id: 'primaryBorrower.contact.occupations',
          type: 'string',
        },
        {
          label: 'Is industry contact',
          id: 'primaryBorrower.contact.isIndustryContact',
          type: 'bool',
        },
        {
          label: 'Marital status',
          id: 'primaryBorrower.maritalStatus',
          type: 'enum',
          options: [
            { label: 'Single', id: 'SINGLE', value: 'SINGLE' },
            { label: 'Married', id: 'MARRIED', value: 'MARRIED' },
            { label: 'Common law', id: 'COMMON_LAW', value: 'COMMON_LAW' },
            { label: 'Separated', id: 'SEPARATED', value: 'SEPARATED' },
            { label: 'Divorced', id: 'DIVORCED', value: 'DIVORCED' },
            { label: 'Widowed', id: 'WIDOWED', value: 'WIDOWED' },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
          ],
        },
        {
          label: 'Number of dependents',
          id: 'primaryBorrower.numberOfDependants',
          type: 'int',
        },
        {
          label: 'Bankruptcy status',
          id: 'primaryBorrower.bankruptcyStatus',
          type: 'enum',
          options: [
            {
              label: 'Never bankrupt',
              id: 'NEVER_BANKRUPT',
              value: 'NEVER_BANKRUPT',
            },
            {
              label: 'Fully discharged',
              id: 'FULLY_DISCHARGED',
              value: 'FULLY_DISCHARGED',
            },
            {
              label: 'Partially discharged',
              id: 'PARTIALLY_DISCHARGED',
              value: 'PARTIALLY_DISCHARGED',
            },
          ],
        },
        {
          label: 'Citizenship type',
          id: 'primaryBorrower.citizenshipType',
          type: 'enum',
          options: [
            { label: 'Citizen', id: 'CITIZEN', value: 'CITIZEN' },
            { label: 'Unknown', id: 'UNKNOWN', value: 'UNKNOWN' },
            { label: 'Resident', id: 'RESIDENT', value: 'RESIDENT' },
            { label: 'Work visa', id: 'WORK_VISA', value: 'WORK_VISA' },
            { label: 'Non resident', id: 'NON_RESIDENT', value: 'NON_RESIDENT' },
            { label: 'Student visa', id: 'STUDENT_VISA', value: 'STUDENT_VISA' },
            {
              label: 'Foreign alien',
              id: 'FOREIGN_ALIEN',
              value: 'FOREIGN_ALIEN',
            },
            {
              label: 'Landed immigrant',
              id: 'LANDED_IMMIGRANT',
              value: 'LANDED_IMMIGRANT',
            },
          ],
        },
        {
          label: 'Relationship to primary',
          id: 'primaryBorrower.relationshipToPrimary',
          type: 'enum',
          options: [
            { label: 'Spouse', id: 'SPOUSE', value: 'SPOUSE' },
            { label: 'Common law', id: 'COMMON_LAW', value: 'COMMON_LAW' },
            {
              label: 'Related family member',
              id: 'RELATED_FAMILY_MEMBER',
              value: 'RELATED_FAMILY_MEMBER',
            },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
            { label: 'Parent', id: 'PARENT', value: 'PARENT' },
            { label: 'Sibling', id: 'SIBLING', value: 'SIBLING' },
            { label: 'Child', id: 'CHILD', value: 'CHILD' },
            { label: 'Grandchild', id: 'GRANDCHILD', value: 'GRANDCHILD' },
            { label: 'Grandparent', id: 'GRANDPARENT', value: 'GRANDPARENT' },
          ],
        },
        {
          label: 'Current address',
          id: 'primaryBorrower.currentAddress.address.displayFull',
          type: 'string',
        },
        {
          label: 'Current monthly rent',
          id: 'primaryBorrower.currentAddress.monthlyRent',
          type: 'currency',
        },
        {
          label: 'Income',
          id: 'primaryBorrower.otherIncome.amount',
          type: 'currency',
        },
        {
          label: 'Employer name',
          id: 'primaryBorrower.employmentHistory.employerName',
          type: 'currency',
        },
        {
          label: 'Employment type',
          id: 'primaryBorrower.employmentHistory.type',
          type: 'enum',
          options: [
            { label: 'Full time', id: 'FULL_TIME', value: 'FULL_TIME' },
            { label: 'Part time', id: 'PART_TIME', value: 'PART_TIME' },
            { label: 'Seasonal', id: 'SEASONAL', value: 'SEASONAL' },
            {
              label: 'Self employed',
              id: 'SELF_EMPLOYED',
              value: 'SELF_EMPLOYED',
            },
            {
              label: 'Receiving benefits',
              id: 'RECEIVING_BENEFITS',
              value: 'RECEIVING_BENEFITS',
            },
          ],
        },
        {
          label: 'Credit score value',
          id: 'primaryBorrower.creditScore.value',
          type: 'int',
        },
      ],
    },
    {
      group: 'Borrowers',
      id: 'borrowers',
      type: 'group',
      subOptions: [
        {
          label: 'Type',
          id: 'borrowers.type',
          type: 'enum',
          options: [
            { label: 'Primary', id: 'PRIMARY', value: 'PRIMARY' },
            { label: 'Secondary', id: 'SECONDARY', value: 'SECONDARY' },
            { label: 'Guarantor', id: 'GUARANTOR', value: 'GUARANTOR' },
          ],
        },
        {
          label: 'Contact ID',
          id: 'borrowers.contact.id',
          type: 'string',
        },
        {
          label: 'Contact salutation',
          id: 'borrowers.contact.salutation',
          type: 'string',
        },
        {
          label: 'Contact first name',
          id: 'borrowers.contact.firstName',
          type: 'string',
        },
        {
          label: 'Contact middle initial',
          id: 'borrowers.contact.middleInitial',
          type: 'string',
        },
        {
          label: 'Contact last name',
          id: 'borrowers.contact.lastName',
          type: 'string',
        },
        {
          label: 'Contact suffix',
          id: 'borrowers.contact.suffix',
          type: 'string',
        },
        {
          label: 'Contact birth date',
          id: 'borrowers.contact.birthDate',
          type: 'datetime',
        },
        { label: 'Contact email', id: 'borrowers.contact.email', type: 'string' },
        {
          label: 'Contact home phone number',
          id: 'borrowers.contact.homePhone.number',
          type: 'string',
        },
        {
          label: 'Contact home phone ext',
          id: 'borrowers.contact.homePhone.ext',
          type: 'string',
        },
        {
          label: 'Contact work phone number',
          id: 'borrowers.contact.workPhone.number',
          type: 'string',
        },
        {
          label: 'Contact work phone ext',
          id: 'borrowers.contact.workPhone.ext',
          type: 'string',
        },
        {
          label: 'Contact cell phone number',
          id: 'borrowers.contact.cellPhone.number',
          type: 'string',
        },
        {
          label: 'Contact cell phone ext',
          id: 'borrowers.contact.cellPhone.ext',
          type: 'string',
        },
        {
          label: 'Contact preferred contact method',
          id: 'borrowers.contact.preferredContact',
          type: 'enum',
          options: [
            { label: 'Home phone', id: 'HOME_PHONE', value: 'HOME_PHONE' },
            { label: 'Work phone', id: 'WORK_PHONE', value: 'WORK_PHONE' },
            { label: 'Cell phone', id: 'CELL_PHONE', value: 'CELL_PHONE' },
            { label: 'Guarantor', id: 'GUARANTOR', value: 'GUARANTOR' },
            { label: 'Fax', id: 'FAX', value: 'FAX' },
            { label: 'Email', id: 'EMAIL', value: 'EMAIL' },
            { label: 'Mail', id: 'MAIL', value: 'MAIL' },
          ],
        },
        {
          label: 'Contact industries',
          id: 'borrowers.contact.industries',
          type: 'string',
        },
        {
          label: 'Contact occupations',
          id: 'borrowers.contact.occupations',
          type: 'string',
        },
        {
          label: 'Is industry contact',
          id: 'borrowers.contact.isIndustryContact',
          type: 'bool',
        },
        {
          label: 'Marital status',
          id: 'borrowers.maritalStatus',
          type: 'enum',
          options: [
            { label: 'Single', id: 'SINGLE', value: 'SINGLE' },
            { label: 'Married', id: 'MARRIED', value: 'MARRIED' },
            { label: 'Common law', id: 'COMMON_LAW', value: 'COMMON_LAW' },
            { label: 'Separated', id: 'SEPARATED', value: 'SEPARATED' },
            { label: 'Divorced', id: 'DIVORCED', value: 'DIVORCED' },
            { label: 'Widowed', id: 'WIDOWED', value: 'WIDOWED' },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
          ],
        },
        {
          label: 'Number of dependents',
          id: 'borrowers.numberOfDependants',
          type: 'int',
        },
        {
          label: 'Bankruptcy status',
          id: 'borrowers.bankruptcyStatus',
          type: 'enum',
          options: [
            {
              label: 'Never bankrupt',
              id: 'NEVER_BANKRUPT',
              value: 'NEVER_BANKRUPT',
            },
            {
              label: 'Fully discharged',
              id: 'FULLY_DISCHARGED',
              value: 'FULLY_DISCHARGED',
            },
            {
              label: 'Partially discharged',
              id: 'PARTIALLY_DISCHARGED',
              value: 'PARTIALLY_DISCHARGED',
            },
          ],
        },
        {
          label: 'Citizenship type',
          id: 'borrowers.citizenshipType',
          type: 'enum',
          options: [
            { label: 'Citizen', id: 'CITIZEN', value: 'CITIZEN' },
            { label: 'Unknown', id: 'UNKNOWN', value: 'UNKNOWN' },
            { label: 'Resident', id: 'RESIDENT', value: 'RESIDENT' },
            { label: 'Work visa', id: 'WORK_VISA', value: 'WORK_VISA' },
            { label: 'Non resident', id: 'NON_RESIDENT', value: 'NON_RESIDENT' },
            { label: 'Student visa', id: 'STUDENT_VISA', value: 'STUDENT_VISA' },
            {
              label: 'Foreign alien',
              id: 'FOREIGN_ALIEN',
              value: 'FOREIGN_ALIEN',
            },
            {
              label: 'Landed immigrant',
              id: 'LANDED_IMMIGRANT',
              value: 'LANDED_IMMIGRANT',
            },
          ],
        },
        {
          label: 'Relationship to primary',
          id: 'borrowers.relationshipToPrimary',
          type: 'enum',
          options: [
            { label: 'Spouse', id: 'SPOUSE', value: 'SPOUSE' },
            { label: 'Common law', id: 'COMMON_LAW', value: 'COMMON_LAW' },
            {
              label: 'Related family member',
              id: 'RELATED_FAMILY_MEMBER',
              value: 'RELATED_FAMILY_MEMBER',
            },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
            { label: 'Parent', id: 'PARENT', value: 'PARENT' },
            { label: 'Sibling', id: 'SIBLING', value: 'SIBLING' },
            { label: 'Child', id: 'CHILD', value: 'CHILD' },
            { label: 'Grandchild', id: 'GRANDCHILD', value: 'GRANDCHILD' },
            { label: 'Grandparent', id: 'GRANDPARENT', value: 'GRANDPARENT' },
          ],
        },
        {
          label: 'Current address',
          id: 'borrowers.currentAddress.address.displayFull',
          type: 'string',
        },
        {
          label: 'Current monthly rent',
          id: 'borrowers.currentAddress.monthlyRent',
          type: 'currency',
        },
        {
          label: 'Income',
          id: 'borrowers.otherIncome.amount',
          type: 'currency',
        },
        {
          label: 'Employer name',
          id: 'borrowers.employmentHistory.employerName',
          type: 'string',
        },
        {
          label: 'Employment type',
          id: 'borrowers.employmentHistory.type',
          type: 'enum',
          options: [
            { label: 'Full time', id: 'FULL_TIME', value: 'FULL_TIME' },
            { label: 'Part time', id: 'PART_TIME', value: 'PART_TIME' },
            { label: 'Seasonal', id: 'SEASONAL', value: 'SEASONAL' },
            {
              label: 'Self employed',
              id: 'SELF_EMPLOYED',
              value: 'SELF_EMPLOYED',
            },
            {
              label: 'Receiving benefits',
              id: 'RECEIVING_BENEFITS',
              value: 'RECEIVING_BENEFITS',
            },
          ],
        },
        {
          label: 'Credit score value',
          id: 'borrowers.creditScore.value',
          type: 'int',
        },
      ],
    },
    {
      group: 'Subject properties',
      id: 'subjectProperties',
      type: 'group',
      subOptions: [
        {
          label: 'MPAC value',
          id: 'subjectProperties.value.MPAC',
          type: 'float',
        },
        {
          label: 'MPAC low value',
          id: 'subjectProperties.value.MPAC_LOW',
          type: 'float',
        },
        {
          label: 'MPAC high value',
          id: 'subjectProperties.value.MPAC_HIGH',
          type: 'float',
        },
        {
          label: 'Purview value',
          id: 'subjectProperties.value.PURVIEW',
          type: 'float',
        },
        {
          label: 'Purview low value',
          id: 'subjectProperties.value.PURVIEW_LOW',
          type: 'float',
        },
        {
          label: 'Purview high value',
          id: 'subjectProperties.value.PURVIEW_HIGH',
          type: 'float',
        },
        {
          label: 'Appraisal value',
          id: 'subjectProperties.value.APPRAISAL',
          type: 'currency',
        },
        {
          label: 'Desktop value',
          id: 'subjectProperties.value.DESKTOP',
          type: 'currency',
        },
        {
          label: 'Applicant Estimate Value',
          id: 'subjectProperties.value.BORROWER',
          type: 'currency',
        },
        {
          label: 'Property address',
          id: 'subjectProperties.address.displayFull',
          type: 'string',
        },
        {
          label: 'Street address',
          id: 'subjectProperties.address.displayLocal',
          type: 'string',
        },
        {
          label: 'Property type',
          id: 'subjectProperties.propertyType',
          type: 'enum',
          options: [
            { label: 'Freehold', id: 'FREEHOLD', value: 'FREEHOLD' },
            { label: 'Leasehold', id: 'LEASEHOLD', value: 'LEASEHOLD' },
            { label: 'Condo', id: 'CONDO', value: 'CONDO' },
          ],
        },
        {
          label: 'Property dwelling type',
          id: 'subjectProperties.dwellingType',
          type: 'enum',
          options: [
            { label: 'Detached', id: 'DETACHED', value: 'DETACHED' },
            {
              label: 'Semi detached',
              id: 'SEMI_DETACHED',
              value: 'SEMI_DETACHED',
            },
            {
              label: 'Duplex detached',
              id: 'DUPLEX_DETACHED',
              value: 'DUPLEX_DETACHED',
            },
            {
              label: 'Duplex semi detached',
              id: 'DUPLEX_SEMI_DETACHED',
              value: 'DUPLEX_SEMI_DETACHED',
            },
            { label: 'Row housing', id: 'ROW_HOUSING', value: 'ROW_HOUSING' },
            {
              label: 'Apartment low rise',
              id: 'APARTMENT_LOW_RISE',
              value: 'APARTMENT_LOW_RISE',
            },
            {
              label: 'Apartment high rise',
              id: 'APARTMENT_HIGH_RISE',
              value: 'APARTMENT_HIGH_RISE',
            },
            { label: 'Mobile', id: 'MOBILE', value: 'MOBILE' },
            {
              label: 'Triplex detached',
              id: 'TRIPLEX_DETACHED',
              value: 'TRIPLEX_DETACHED',
            },
            {
              label: 'Triplex semi detached',
              id: 'TRIPLEX_SEMI_DETACHED',
              value: 'TRIPLEX_SEMI_DETACHED',
            },
            { label: 'Stacked', id: 'STACKED', value: 'STACKED' },
            {
              label: 'Modular home detached',
              id: 'MODULAR_HOME_DETACHED',
              value: 'MODULAR_HOME_DETACHED',
            },
            {
              label: 'Modular home semi detached',
              id: 'MODULAR_HOME_SEMI_DETACHED',
              value: 'MODULAR_HOME_SEMI_DETACHED',
            },
            {
              label: 'Four plex detached',
              id: 'FOUR_PLEX_DETACHED',
              value: 'FOUR_PLEX_DETACHED',
            },
            {
              label: 'Four plex semi detached',
              id: 'FOUR_PLEX_SEMI_DETACHED',
              value: 'FOUR_PLEX_SEMI_DETACHED',
            },
          ],
        },
        { label: 'Property age', id: 'subjectProperties.age', type: 'int' },
        {
          label: 'Property tenure',
          id: 'subjectProperties.tenure',
          type: 'enum',
          options: [
            { label: 'Freehold', id: 'FREEHOLD', value: 'FREEHOLD' },
            { label: 'Leasehold', id: 'LEASEHOLD', value: 'LEASEHOLD' },
            { label: 'Condo', id: 'CONDO', value: 'CONDO' },
          ],
        },
        {
          label: 'Property is owner occupied',
          id: 'subjectProperties.isOwnerOccupied',
          type: 'bool',
        },
        {
          label: 'Property is rental',
          id: 'subjectProperties.isRental',
          type: 'bool',
        },
        {
          label: 'Future LTV',
          id: 'subjectProperties.maximumFutureLtv',
          type: 'float',
        },
      ],
    },
    {
      group: 'Applications',
      id: 'applications',
      type: 'group',
      subOptions: [
        {
          label: 'Application state',
          id: 'selectedApplication.state',
          type: 'enum',
          options: [
            { label: 'Initial', id: 'INITIAL', value: 'INITIAL' },
            { label: 'Option', id: 'OPTION', value: 'OPTION' },
            { label: 'Preparing', id: 'PREPARING', value: 'PREPARING' },
            {
              label: 'Lender submitted',
              id: 'LENDER_SUBMITTED',
              value: 'LENDER_SUBMITTED',
            },
            {
              label: 'Lender approved',
              id: 'LENDER_APPROVED',
              value: 'LENDER_APPROVED',
            },
            {
              label: 'Borrower submitted',
              id: 'BORROWER_SUBMITTED',
              value: 'BORROWER_SUBMITTED',
            },
            {
              label: 'Borrower approved',
              id: 'BORROWER_APPROVED',
              value: 'BORROWER_APPROVED',
            },
            { label: 'Funded', id: 'FUNDED', value: 'FUNDED' },
            { label: 'Funded paid', id: 'FUNDED_PAID', value: 'FUNDED_PAID' },
            {
              label: 'Funded complete',
              id: 'FUNDED_COMPLETE',
              value: 'FUNDED_COMPLETE',
            },
            {
              label: 'Funded archived',
              id: 'FUNDED_ARCHIVED',
              value: 'FUNDED_ARCHIVED',
            },
            {
              label: 'Client cancelled',
              id: 'CLIENT_CANCELLED',
              value: 'CLIENT_CANCELLED',
            },
            {
              label: 'Lender declined',
              id: 'LENDER_DECLINED',
              value: 'LENDER_DECLINED',
            },
            {
              label: 'Client rejected',
              id: 'CLIENT_REJECTED',
              value: 'CLIENT_REJECTED',
            },
            { label: 'Closed', id: 'CLOSED', value: 'CLOSED' },
          ],
        },
        {
          label: 'Application affiliate commission',
          id: 'selectedApplication.affiliateCommissionDollars',
          type: 'currency',
        },
        {
          label: 'Application monthly payment saving',
          id: 'selectedApplication.monthlyPaymentSavingDollars',
          type: 'currency',
        },
        {
          label: 'Application remaining balance saving',
          id: 'selectedApplication.remainingBalanceSavingDollars',
          type: 'currency',
        },
        {
          label: 'Application total interest savings dollars',
          id: 'selectedApplication.totalInterestSavingsDollars',
          type: 'currency',
        },
        {
          label: 'Application closing date',
          id: 'selectedApplication.closingDate',
          type: 'datetime',
        },
        {
          label: 'Application interest adjustment date',
          id: 'selectedApplication.interestAdjustmentDate',
          type: 'datetime',
        },
        {
          label: 'Application first payment date',
          id: 'selectedApplication.firstPaymentDate',
          type: 'datetime',
        },
        {
          label: 'Application maturity date',
          id: 'selectedApplication.maturityDate',
          type: 'datetime',
        },
        {
          label: 'Application is lender',
          id: 'selectedApplication.isLender',
          type: 'bool',
        },
        {
          label: 'Application fees',
          id: 'selectedApplication.fees.amount',
          type: 'currency',
        },
        {
          label: 'Application total mortgages paid from proceeds',
          id: 'selectedApplication.totalMortgagesPaidFromProceeds',
          type: 'currency',
        },
        {
          label: 'Application total liabilities paid from proceeds',
          id: 'selectedApplication.totalLiabilitiesPaidFromProceeds',
          type: 'currency',
        },
        {
          label: 'Application total fees paid at closing',
          id: 'selectedApplication.totalFeesPaidAtClosing',
          type: 'currency',
        },
        {
          label: 'Application total fees paid from proceeds',
          id: 'selectedApplication.totalFeesPaidFromProceeds',
          type: 'currency',
        },
        {
          label: 'Application total fees',
          id: 'selectedApplication.totalFees',
          type: 'currency',
        },
        {
          label: 'Total broker fees',
          id: 'selectedApplication.totalBrokerFees',
          type: 'currency',
        },
        {
          label: 'Total appraisal fees',
          id: 'selectedApplication.totalAppraisalFees',
          type: 'currency',
        },
        {
          label: 'Total mortgage renewal fees',
          id: 'selectedApplication.totalMortgageRenewalFees',
          type: 'currency',
        },
        {
          label: 'Total legal fees',
          id: 'selectedApplication.totalLegalFees',
          type: 'currency',
        },
        {
          label: 'Total mortgage insurance tax fees',
          id: 'selectedApplication.totalMortgageInsuranceTaxFees',
          type: 'currency',
        },
        {
          label: 'Total commitment fees',
          id: 'selectedApplication.totalOtherLenderFees',
          type: 'currency',
        },
        {
          label: 'Total other fees',
          id: 'selectedApplication.totalOtherFees',
          type: 'currency',
        },
        {
          label: 'Application total product payment from proceeds',
          id: 'selectedApplication.totalProductPaymentFromProceeds',
          type: 'currency',
        },
        {
          label: 'Application total product payment at closing',
          id: 'selectedApplication.totalProductPaymentAtClosing',
          type: 'currency',
        },
        {
          label: 'Application total product payment at maturity',
          id: 'selectedApplication.totalProductPaymentAtMaturity',
          type: 'currency',
        },
        {
          label: 'Application total commission value',
          id: 'selectedApplication.totalCommissionValue',
          type: 'currency',
        },
        {
          label: 'Application expert id',
          id: 'selectedApplication.expertId',
          type: 'string',
        },
        {
          label: 'Application commission paid',
          id: 'selectedApplication.commissionPaid',
          type: 'bool',
        },
        { label: 'Application tag', id: 'tags', type: 'string' },
        {
          label: 'Has products',
          id: 'selectedApplication.products.0',
          type: 'bool',
        },
        {
          label: 'Max loan amount',
          id: 'selectedApplication.benchmark.maximumLoanDollars',
          type: 'currency',
        },
      ],
    },
    {
      group: 'Product',
      id: 'product',
      type: 'group',
      subOptions: [
        {
          label: 'Product id',
          id: 'selectedApplication.products.id',
          type: 'string',
        },
        {
          label: 'Lender name',
          id: 'selectedApplication.products.lender.name',
          type: 'string',
        },
        {
          label: 'Term in months',
          id: 'selectedApplication.products.termMonths',
          type: 'int',
        },
        {
          label: 'Amortization in months',
          id: 'selectedApplication.products.amortizationMonths',
          type: 'int',
        },
        {
          label: 'Has amortization',
          id: 'selectedApplication.products.hasAmortization',
          type: 'bool',
        },
        {
          label: 'Interest only',
          id: 'selectedApplication.products.interestOnly',
          type: 'bool',
        },
        {
          label: 'Compounding frequency',
          id: 'selectedApplication.products.compoundingPeriodsPerYear',
          type: 'enum',
          options: [
            { value: null, label: 'All', id: 'All' },
            { value: 1, label: 'Annually', id: 'Annually' },
            { value: 2, label: 'Semi annually', id: 'Semi-annually' },
            { value: 4, label: 'Quarterly', id: 'Quarterly' },
            { value: 12, label: 'Monthly', id: 'Monthly' },
            { value: 24, label: 'Semi monthly', id: 'Semi-monthly' },
            { value: 26, label: 'Bi weekly', id: 'Bi-weekly' },
            { value: 52, label: 'Weekly', id: 'Weekly' },
          ],
        },
        {
          label: 'Term type',
          id: 'selectedApplication.products.termType',
          type: 'enum',
          options: [
            { value: 'OPEN', label: 'Open', id: 'OPEN' },
            { value: 'CLOSED', label: 'Closed', id: 'CLOSED' },
            { value: 'CONVERTIBLE', label: 'Convertible', id: 'CONVERTIBLE' },
          ],
        },
        {
          label: 'Commission',
          id: 'selectedApplication.products.commission',
          type: 'float',
        },
        {
          label: 'Interest rate',
          id: 'selectedApplication.products.effectiveRate',
          type: 'float',
        },
        {
          label: 'Buy down',
          id: 'selectedApplication.products.commissionAppliedToBuyDownRate',
          type: 'float',
        },
        {
          label: 'Commission value',
          id: 'selectedApplication.products.commissionValue',
          type: 'currency',
        },
        {
          label: 'Total payment',
          id: 'selectedApplication.products.totalPaymentFromNowUntilEndOfTerm',
          type: 'currency',
        },
        {
          label: 'Maturity date',
          id: 'selectedApplication.products.maturityDate',
          type: 'datetime',
        },
        {
          label: 'Insurance type',
          id: 'selectedApplication.products.type',
          type: 'enum',
          options: [
            { value: 'CONVENTIONAL', label: 'Conventional', id: 'CONVENTIONAL' },
            { value: 'INSURABLE', label: 'Insurable', id: 'INSURABLE' },
            { value: 'INSURED', label: 'Insured', id: 'INSURED' },
            { value: 'RENTAL', label: 'Rental', id: 'RENTAL' },
          ],
        },
        {
          label: 'Monthly mortgage payment reduction dollars',
          id:
            'selectedApplication.products.monthlyMortgagePaymentReductionDollars',
          type: 'currency',
        },
        {
          label: 'GDS',
          id: 'selectedApplication.products.gds',
          type: 'float',
        },
        {
          label: 'TDS',
          id: 'selectedApplication.products.tds',
          type: 'float',
        },
        {
          label: 'Mortgage amount dollars',
          id: 'selectedApplication.products.mortgageAmountDollars',
          type: 'currency',
        },
        {
          label: 'Name',
          id: 'selectedApplication.products.name',
          type: 'string',
        },
        {
          label: 'Posted rate',
          id: 'selectedApplication.products.postedRate',
          type: 'float',
        },
        {
          label: 'Term elapsed months',
          id: 'selectedApplication.products.termElapsedMonths',
          type: 'int',
        },
        {
          label: 'Payoff type',
          id: 'selectedApplication.products.payoffType',
          type: 'enum',
          options: [
            {
              value: 'PRIOR_TO_ADVANCE',
              label: 'Prior to advance',
              id: 'PRIOR_TO_ADVANCE',
            },
            { value: 'AT_MATURITY', label: 'At maturity', id: 'AT_MATURITY' },
            {
              value: 'FROM_PROCEEDS',
              label: 'From proceeds',
              id: 'FROM_PROCEEDS',
            },
          ],
        },
      ],
    },
    {
      group: 'General',
      id: 'general',
      type: 'group',
      subOptions: [
        {
          label: 'Current Date',
          id: 'general.current.date',
          type: 'string',
        },
        {
          label: 'Current Day',
          id: 'general.current.day',
          type: 'string',
        },
        {
          label: 'Current Month',
          id: 'general.current.month',
          type: 'string',
        },
        {
          label: 'Current Year',
          id: 'general.current.year',
          type: 'string',
        },
      {
        label: 'Marketing Rate (Use with custom stub suffix)',
        id: 'general.marketingRate.stub',
        type: 'string',
      }
      ],
    },
    {
      group: 'Modifiers',
      id: 'modifiers',
      type: 'group',
      subOptions: [

        {
          label: 'Add Percent',
          id: 'modifiers.addPercent.5.0',
          type: 'string',
        },
        {
          label: 'Normalize Rates',
          id: 'modifiers.normalizeRates',
          type: 'string',
        },
        {
          label: 'Currency',
          id: 'modifiers.currency',
          type: 'string',
        },
        {
          label: 'Phone',
          id: 'modifiers.phone',
          type: 'string',
        },
        {
          label: 'Capitalise',
          id: 'modifiers.Capitalise',
          type: 'string',
        },
        {
          label: 'Currency Rounded',
          id: 'modifiers.currencyRounded',
          type: 'string',
        },
        {
          label: 'Format Date',
          id: 'modifiers.date.format',
          type: 'string',
        },
        {
          label: 'Add Days',
          id: 'modifiers.date.addDays.1',
          type: 'string',
        },
        {
          label: 'Days Until',
          id: 'modifiers.date.daysUntil',
          type: 'string',
        },
      ],
    },
    {
      group: 'Contact',
      id: 'contact',
      type: 'group',
      subOptions: [
        { label: 'First Name', id: 'contact.firstName', type: 'string' },
        { label: 'Middle Initial', id: 'contact.middleInitial', type: 'string' },
        { label: 'Last Name', id: 'contact.lastName', type: 'string' },
        { label: 'Email', id: 'contact.email', type: 'string' },
        { label: 'Birth Date', id: 'contact.birthDate', type: 'datetime' },
        { label: 'Legacy Id', id: 'contact.legacyId', type: 'int', },
        // Need to Add In Future
        // { label: 'Sin', id: 'contact.sin', type: 'string' },
        { label: 'Prevent Contact', id: 'contact.preventContact', type: 'bool' },
        { label: 'Is Investor', id: 'contact.isInvestor', type: 'bool' },
        { label: 'Is Investor Lead', id: 'contact.isInvestorLead', type: 'bool' },
        { label: 'Subscribed To News Letter', id: 'contact.subscribedToNewsletter', type: 'bool' },
        { label: 'Origin', id: 'contact.origin', type: 'string' },
        { label: 'Affiliate Key', id: 'contact.affiliateKey', type: 'string' },
        { label: 'Prevent Credit Monitoring', id: 'contact.preventCreditMonitoring', type: 'bool' },
        { label: 'Prevent Email', id: 'contact.preventEmail', type: 'bool' },
        { label: 'Is Associate', id: 'contact.isAssociate', type: 'bool' },
        { label: 'Last Activity Date', id: 'contact.lastActivityDate', type: 'datetime' },
        { label: 'Created date', id: 'contact.createdDate', type: 'datetime' },
        {
          label: 'Home Phone Number',
          id: 'contact.homePhone.number',
          type: 'string',
        },
        {
          label: 'Home Phone Ext',
          id: 'contact.homePhone.ext',
          type: 'string',
        },
        {
          label: 'Work Phone Number',
          id: 'contact.workPhone.number',
          type: 'string',
        },
        {
          label: 'Work phone Ext',
          id: 'contact.workPhone.ext',
          type: 'string',
        },
        {
          label: 'Cell Phone Number',
          id: 'contact.cellPhone.number',
          type: 'string',
        },
        {
          label: 'Cell Phone ext',
          id: 'contact.cellPhone.ext',
          type: 'string',
        },
        {
          label: 'Marital status',
          id: 'contact.maritalStatus',
          type: 'enum',
          options: [
            { label: 'Single', id: 'SINGLE', value: 'SINGLE' },
            { label: 'Married', id: 'MARRIED', value: 'MARRIED' },
            { label: 'Common law', id: 'COMMON_LAW', value: 'COMMON_LAW' },
            { label: 'Separated', id: 'SEPARATED', value: 'SEPARATED' },
            { label: 'Divorced', id: 'DIVORCED', value: 'DIVORCED' },
            { label: 'Widowed', id: 'WIDOWED', value: 'WIDOWED' },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
          ],
        },
        {
          label: 'Preferred Contact Method',
          id: 'contact.preferredContact',
          type: 'enum',
          options: [
            { label: 'Home phone', id: 'HOME_PHONE', value: 'HOME_PHONE' },
            { label: 'Work phone', id: 'WORK_PHONE', value: 'WORK_PHONE' },
            { label: 'Cell phone', id: 'CELL_PHONE', value: 'CELL_PHONE' },
            { label: 'Guarantor', id: 'GUARANTOR', value: 'GUARANTOR' },
            { label: 'Fax', id: 'FAX', value: 'FAX' },
            { label: 'Email', id: 'EMAIL', value: 'EMAIL' },
            { label: 'Mail', id: 'MAIL', value: 'MAIL' },
          ],
        },
        {
          label: 'Referral Source',
          id: 'contact.referralSource',
          type: 'enum',
          options: [
            { label: 'Agent', id: 'AGENT', value: 'AGENT' },
            { label: 'Friend or Family', id: 'FRIEND_OR_FAMILY', value: 'FRIEND_OR_FAMILY' },
            { label: 'Google', id: 'GOOGLE', value: 'GOOGLE' },
            { label: 'FB or Instagram', id: 'FB_INSTAGRAM', value: 'FB_INSTAGRAM' },
            { label: 'Internet', id: 'INTERNET', value: 'INTERNET' },
            { label: 'Other Internet', id: 'OTHER_INTERNET', value: 'OTHER_INTERNET' },
            { label: 'TV', id: 'TV', value: 'TV' },
            { label: 'Radio', id: 'RADIO', value: 'RADIO' },
            { label: 'Other', id: 'OTHER', value: 'OTHER' },
          ],
        },
        {
          label: 'Best Time To Contact',
          id: 'contact.bestTimeToContact',
          type: 'enum',
          options: [
            { label: 'Anytime', id: 'ANYTIME', value: 'ANYTIME' },
            { label: 'Morning', id: 'MORNING', value: 'MORNING' },
            { label: 'Daytime', id: 'DAYTIME', value: 'DAYTIME' },
            { label: 'Evening', id: 'EVENING', value: 'EVENING' },
            { label: 'Weekend', id: 'WEEKEND', value: 'WEEKEND' },
          ],
        },
        {
          label: 'Account Types',
          id: 'contact.accountTypes',
          type: 'enum',
          options: [
            { label: 'TFSA', id: 'TFSA', value: 'TFSA' },
            { label: 'RRSP', id: 'RRSP', value: 'RRSP' },
            { label: 'RESP', id: 'RESP', value: 'RESP' },
            { label: 'OTHER', id: 'OTHER', value: 'OTHER' },
            { label: 'UNSURE', id: 'UNSURE', value: 'UNSURE' },
          ],
        },
      ]
    }
  ]
